<template>
  <div class="container is-widescreen">
    <div class="columns">
      <div class="column">
        <Alter />
      </div>
      <div class="column">
        <DoI />
      </div>
    </div>
  </div>
</template>

<script>
import Alter from "./components/Alter.vue";
import DoI from "./components/DatesOfInterest.vue";

export default {
  name: "app",
  components: {
    Alter,
    DoI
  }
};
</script>